const isSuperAdmin = (meta) => meta.dispatch(isSuperAdminGuardAction(meta));

const isSuperAdminGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	if (state.auth.user.role.some((role)=>role.name === "Super Admin")) {
		return null
	}

	return '/'
}

export { isSuperAdmin };
